import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=6a147dbc&scoped=true&"
import script from "./Mark.vue?vue&type=script&lang=ts&"
export * from "./Mark.vue?vue&type=script&lang=ts&"
import style1 from "./Mark.vue?vue&type=style&index=1&id=6a147dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a147dbc",
  null
  
)

export default component.exports